import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const Dashboard = () => {
  return (
    <Container fluid>
      <h1 className="mt-4">Admin Dashboard</h1>
      <p>Welcome to the protected admin area. You are successfully logged in.</p>
    </Container>
  );
};

export default Dashboard;